import React from 'react'
import classes from './report.module.css'
import { formatDate } from '../../../../../../components/Table/TableCells/TableCell'
// import { Typography } from '@mui/material'
import { chalkwidettx, newlogo } from '../../../../../../assets/icons'
import { StaticAlt } from '../../../../../../shared/utils/constants'

// const ReportItem = ({ label, value }) => (
//   <Typography fontSize={'4px'} mb={1}>
//     <span className={classes['item-label']}>{label}</span> :{' '}
//     <span className={classes['r-item-label']}>{value}</span>
//   </Typography>
// )

const Report = ({ feeInfo, studentInfo }) => {
  // console.log('-------feeinfo', feeInfo)

  // const feeBalance = (feeInfo && feeInfo[0] && feeInfo[0]?.fee_balance) || 0
  // const lastYDue = (feeInfo && feeInfo[0] && feeInfo[0]?.fee_last_year_due) || 0
  // const transportFee = (feeInfo && feeInfo[0] && feeInfo[0]?.fee_transport_fee) || 0
  // const misc = (feeInfo && feeInfo[0] && feeInfo[0]?.fee_misc_fee) || 0
  // const discountFee = (feeInfo && feeInfo[0] && feeInfo[0]?.fee_discount) || 0
  // const feeAmount = (feeInfo && feeInfo[0] && feeInfo[0]?.fee_amount) || 0
  // const totalAmount = (feeInfo && feeInfo[0] && feeInfo[0]?.fee_total) || 0

  // const schoolImage = studentInfo?.school_avatar
  // const checkSchoolImage = schoolImage && schoolImage !== '' && schoolImage !== null
  // console.log('--------studentinfo', studentInfo)
  const FeeContent = ({ label, value }) => {
    return (
      <div className={classes.boxitem}>
        <p className={classes.label}>{label}</p>
        <p className={classes.value}>{value}</p>
      </div>
    )
  }
  // const totals = feeInfo?.reduce((acc, curr) => {
  //   for (let key in curr) {
  //     if (typeof curr[key] === 'number') {
  //       acc[key] = (acc[key] || 0) + curr[key]
  //     }
  //   }
  //   return acc
  // }, {})

  return (
    <div className={classes.reportFile}>
      {/* <div className={checkSchoolImage && classes.reportHead}>
        {checkSchoolImage && <img src={schoolImage} alt="" className={classes.reportImage} />}

        <h1 className={classes['report-head']}>{studentInfo?.school_name}</h1>
      </div>

      <div className={classes['report-data-col']}>
        <div style={{ width: '65%' }}>
          <ReportItem label="Student Name" value={studentInfo?.student_name} />
          <ReportItem label="Father's Name" value={studentInfo?.student_father_name} />
          <ReportItem
            label="Bill Number"
            value={payments && payments[0] && payments[0]?.payment_id}
          />
          <ReportItem label="Transport Fee" value={`₹${transportFee}`} />
          <ReportItem label="Misc Fee" value={`₹${misc}`} />
        </div>
        <div style={{ width: '35%' }}>
          <ReportItem label="Reg Number" value={studentInfo?.student_registration_number} />
          <ReportItem
            label="Class"
            value={`${studentInfo?.student_grade} - ${studentInfo?.student_section}`}
          />
          <ReportItem label="Fee" value={`₹${feeAmount}`} />
          <ReportItem label="Discount" value={`₹${discountFee}`} />
          <ReportItem label="Last Year Due" value={`₹${lastYDue}`} />
          <ReportItem label="Total Fees" value={`₹${totalAmount}`} />
        </div>
      </div>

      <div className={classes['report-bill']}>
        <table className={classes['report-table']}>
          <thead>
            <tr>
              <th className={classes['report-th']}>Bill Number</th>
              <th className={classes['report-th']}>Date</th>
              <th className={classes['report-th']}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {payments?.map((payment, index) => (
              <tr key={index}>
                <td className={classes['report-td']}>{payment.payment_id}</td>
                <td className={classes['report-td']}>{formatDate(payment.createdAt)}</td>
                <td className={classes['report-td']}>₹{payment.payment_amount}</td>
              </tr>
            ))}
            <tr className={`${classes['report-total-row']} total-row`}>
              <td className={classes['report-td']} colSpan={2} style={{ textAlign: 'right' }}>
                Balance:
              </td>
              <td className={classes['report-td']}>₹{feeBalance}</td>
            </tr>
          </tbody>
        </table>
      </div> */}

      <div className={classes.top}>
        <img className={classes.logo} src={newlogo} alt={StaticAlt} />
        <img className={classes.logotxt} src={chalkwidettx} alt={StaticAlt} />
      </div>
      {/* <div className={checkSchoolImage && classes.reportHead}>
        {checkSchoolImage && <img src={schoolImage} alt="" className={classes.reportImage} />}
      </div> */}
      {/* <div className={classes.studentsection}>
        <p className={classes.title}>Student</p>
        <div className={classes.box}>
          <FeeContent label={'Student Name'} value={studentInfo?.student_name} />
          <FeeContent
            label={'Student Registration Id'}
            value={studentInfo?.student_registration_number}
          />
          <FeeContent label={'Student ID'} value={studentInfo?.student_id} />
          <FeeContent label={'Father Name'} value={studentInfo?.student_name} />
        </div>
        <div className={classes.box}>
          <FeeContent label={'Tuition Fee'} value={totals?.payment_tuition_fee} />
          <FeeContent label={'Exam Fee'} value={totals?.payment_exam_fee} />
          <FeeContent label={'Transport Fee'} value={totals?.payment_transport_fee} />
          <FeeContent label={'Misc Fee'} value={totals?.payment_misc_fee} />
          <FeeContent label={'Discount'} value={totals?.payment_monthly_discount} />
          <FeeContent label={'Last Year Due'} value={totals?.payment_last_year_due_fee} />
          <hr className={classes.rule} />
          <FeeContent label={'Total Amount'} value={totals?.payment_total_amount} />
        </div>
      </div> */}
      <div className={classes.studentsection}>
        {/* <p className={classes.title}>Student</p> */}
        <div className={classes.box}>
          <FeeContent label={'Student Name'} value={studentInfo?.student_name} />
          <FeeContent
            label={'Student Registration Id'}
            value={studentInfo?.student_registration_number}
          />
          <FeeContent label={'Student ID'} value={studentInfo?.student_id} />
          <FeeContent label={'Father Name'} value={studentInfo?.student_father_name} />
        </div>
        {/* <p className={classes.title}>Fees</p> */}
        <div className={classes.box}>
          {feeInfo?.map((fee, index) => (
            <div key={index}>
              {/* Only show Tuition Fee once (for first item only) */}
              {index === 0 && (
                <>
                  <FeeContent label={'Month'} value={fee?.payment_month} />
                  <FeeContent label={'Tuition Fee'} value={fee?.payment_tuition_fee || 0} />
                </>
              )}

              {/* Other fields per record */}
              <FeeContent label={'Date'} value={formatDate(fee?.createdAt)} />
              <FeeContent label={'Exam Fee'} value={fee?.payment_exam_fee || 0} />
              <FeeContent label={'Transport Fee'} value={fee?.payment_transport_fee || 0} />
              <FeeContent label={'Misc Fee'} value={fee?.payment_misc_fee || 0} />
              <FeeContent label={'Discount'} value={fee?.payment_monthly_discount || 0} />
              <FeeContent label={'Last Year Due'} value={fee?.payment_last_year_due_fee || 0} />
              <hr className={classes.rule} />
            </div>
          ))}

          {/* Total from all records' payment_total_amount */}
          <FeeContent
            label={'Total Amount'}
            value={feeInfo?.reduce((sum, fee) => sum + (fee?.payment_total_amount || 0), 0) || 0}
          />
        </div>
        {/* Displaying fee info */}
      </div>
    </div>
  )
}

export default Report
